import React, { useState } from "react";
import styles from "../../../../styles/brsr/general.module.css";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import LensIcon from "@mui/icons-material/Lens";
import EssentialIndicator from "../../../../Components/BRSR/SectionC/Principle2/EssentialIndicator";
import LeadershipIndicator from "../../../../Components/BRSR/SectionC/Principle2/LeadershipIndicator";

const Principle2 = () => {
  const [currentComponent, setCurrentComponent] = useState("Essential");

  const steps = ["Essential", "Leadership"];

  const DottedLineBetweenSteps = () => {
    return (
      <div
        style={{
          width: "100%",
          height: "3px",
          background:
            "repeating-linear-gradient(to right, #B3B3B3, #B3B3B3 10px, transparent 5px, transparent 15px)",
        }}
      />
    );
  };

  const goToNextComponent = () => {
    const currentIndex = steps.findIndex((step) => step === currentComponent);
    if (currentIndex < steps.length - 1) {
      setCurrentComponent(steps[currentIndex + 1]);
    }
  };
  return (
    <>
      <div className={styles.section_navbar}>
        <div className={styles.sectionc_navbar_wrapper}>
          <div onClick={() => setCurrentComponent("Essential")}>
            {currentComponent === "Essential" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
          {DottedLineBetweenSteps()}
          <div onClick={() => setCurrentComponent("Leadership")}>
            {currentComponent === "Leadership" ? (
              <RadioButtonUncheckedIcon sx={{ color: "#EB7E0E" }} />
            ) : (
              <LensIcon sx={{ color: "#A8A8A8" }} />
            )}
          </div>
        </div>

        <div className={styles.sectionc_navbar_steps}>
          <p>Essential Indicator</p>
          <p>Leadership Indicator</p>
        </div>
      </div>
      <div>
        {currentComponent === "Essential" ? (
          <p className={styles.section_heading}>
            PRINCIPLE 2:
            <p className={styles.section_title}>
              Businesses should provide goods and services in a manner that is
              sustainable and safe
            </p>
          </p>
        ) : currentComponent === "Leadership" ? (
          <p className={styles.section_heading}>
            PRINCIPLE 2:
            <p className={styles.section_title}>
              Businesses should respect the interests of and be responsive to
              all its stakeholders
            </p>
          </p>
        ) : null}
      </div>

      <div>
        {currentComponent === "Essential" ? (
          <EssentialIndicator onSave={goToNextComponent} />
        ) : currentComponent === "Leadership" ? (
          <LeadershipIndicator onSave={goToNextComponent} />
        ) : null}
      </div>
    </>
  );
};

export default Principle2;
